<template>
  <div>All Pipelines</div>
</template>

<script>
export default {
  name: "all_pipelines"
}
</script>

<style scoped>

</style>
